import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m13.98 26.833 4.194-7.372c2.017-3.743 3.993-7.986 3.993-10.188 0-4.483-3.67-8.106-8.167-8.106-4.517 0-8.167 3.643-8.167 8.106 0 2.202 1.976 6.445 3.993 10.188l4.154 7.372Zm0-21.843c2.359 0 4.275 1.901 4.275 4.243 0 2.342-1.916 4.243-4.275 4.243-2.36 0-4.275-1.901-4.275-4.243-.02-2.342 1.915-4.243 4.275-4.243Z",
		fill: "#fff"
	})
});
const ForwardRef = forwardRef(SvgLocationmin);
export { ForwardRef as ReactComponent };
